module.exports = __webpack_public_path__ + "img/Select@2x.febc8849.png";